<template>
  <a type="button" class="copy-button" @click="copy">
    <i class="ag-icon ag-icon_copy pl-2 ml-2 mr-2"></i>
  </a>
</template>

<script>
import { notify } from "@kyvg/vue3-notification";

export default {
  props: {
    text: {},
  },
  methods: {
    async copy() {
      try {
        await navigator.clipboard.writeText(this.text);
        notify({
          title: "Copied",
          type: "success",
          duration: 3000,
        });
      } catch ($e) {
        notify({
          title: "Cannot copy",
          type: "error",
          duration: 3000,
        });
      }
    },
  },
};
</script>

